export class InfectedDataByClassification {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "infectedDataClasses",
            "baseName": "infectedDataClasses",
            "type": "Array<InfectedDataClassificationSize>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InfectedDataByClassification.attributeTypeMap;
    }
    constructor() {
    }
}
